import { store as base } from '../base';
import { store as CZ } from './CZ';
import { store as HU } from './HU';
import { store as SK } from './SK';

export const featureConfigMap = {
    base,
    CZ,
    HU,
    SK,
};
